import { useContext, useMemo } from 'react';

import { auth } from '../../config/firebase';
import { DataContext } from '../data/DataContext';
import { DataContextType } from '../data_types/interfaces';
import { getMyRounds, getScoringSummary } from '../data/scorecard_insights';

/** The signed-in player's scored rounds this season and their to-par summary. */
const useMyRounds = () => {
    const context = useContext<DataContextType | undefined>(DataContext);
    const { historyData, matchData } = context || {};
    const myPID = auth.currentUser?.uid ?? '';

    return useMemo(() => {
        const rounds = getMyRounds(myPID, historyData ?? [], matchData ?? []);
        return { rounds, summary: getScoringSummary(rounds) };
    }, [myPID, historyData, matchData]);
};

export default useMyRounds;
